import { render, staticRenderFns } from "./ChannelEdit.vue?vue&type=template&id=c210ac6c&"
import script from "./ChannelEdit.vue?vue&type=script&lang=js&"
export * from "./ChannelEdit.vue?vue&type=script&lang=js&"
import style0 from "./ChannelEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QList,QExpansionItem,QCard,QCardSection,QInput,QSelect,QItem,QItemSection,QBtn,QSpinnerHourglass} from 'quasar'
component.options.components = Object.assign({QPage,QList,QExpansionItem,QCard,QCardSection,QInput,QSelect,QItem,QItemSection,QBtn,QSpinnerHourglass}, component.options.components || {})
